import { FC, ReactNode } from "react";
import { useTranslation } from "react-i18next";
import { Flex, Text, Link } from "@chakra-ui/react";

interface Props {
  children: ReactNode;
  showViewAll?: boolean;
  onViewAll?: () => void;
}

export const LabTestsContainer: FC<Props> = ({
  children,
  showViewAll = false,
  onViewAll,
}) => {
  const { t } = useTranslation();

  return (
    <Flex bg="th.white" w="full" py="60px" justify="center">
      <Flex direction="column" align="center" gap="60px" w="full">
        <Flex
          direction="column"
          gap="30px"
          align="center"
          maxW="704px"
          w="full"
          px={4}
        >
          <Text
            fontSize="44px"
            fontWeight="700"
            fontFamily="Moderat Extended Bold, sans-serif"
            lineHeight="1.1"
            textAlign="center"
            color="th.black"
            w="full"
          >
            {t("diagnosticDashboard.labTest.containerHeading")}
          </Text>
          <Flex direction="column" gap="14px" w="full">
            {children}
          </Flex>
          {showViewAll && (
            <Link
              fontSize="16px"
              fontWeight="400"
              color="th.black"
              lineHeight="1.4"
              textAlign="center"
              textDecoration="underline"
              _hover={{ textDecoration: "underline" }}
              onClick={onViewAll}
              cursor="pointer"
            >
              {t("diagnosticDashboard.labTest.viewAll")}
            </Link>
          )}
        </Flex>
      </Flex>
    </Flex>
  );
};
